import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import { API, RISKMGT } from '@const'
import * as utils from '@utils'
import Checkbox from '@material-ui/core/Checkbox'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Divider from '@material-ui/core/Divider'
import { FormControlLabel, FormControl, InputLabel, Select, MenuItem, TextField, Grid } from '@material-ui/core'

const initialState = {
    gameRiskInfo: {},
    input: {},
    rtp_level_list: [],
    ban_multiple_unset: false,
    dialogOpen: false,
    isLoading: false,
}

class EditRiskInfoDialog extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key, options) => {
            return utils.t(key, 'EditRiskInfoDialog', options)
        }
        this.state = initialState
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    reset(inputs, gameRiskInfo) {
        let anotherRiskLabel
        switch (inputs.risk_label) {
            case RISKMGT.RISK_LABEL_HONEYMOON_1:
                anotherRiskLabel = RISKMGT.RISK_LABEL_HONEYMOON_2
                break
            default:
                break
        }
        const anotherRiskInfo = gameRiskInfo[utils.ComposeGameRiskInfoKey(inputs.oid, anotherRiskLabel, inputs.pf_sub_pf_id)]

        this.setState({
            input: {
                ...inputs,
                another_rtp_level: this.isShowAnotherGameRiskInfoRtp(inputs.risk_label) ? anotherRiskInfo.rtp_level : '',
            },
            gameRiskInfo: gameRiskInfo,
            ban_multiple_unset: inputs.ban_multiple < 0,
            isLoading: false,
        })
    }

    OpenDialog(inputs, gameRiskInfo) {
        this.reset(inputs, gameRiskInfo)
        this.queryData()
        this.setState({ dialogOpen: true })
    }

    closeDialog() {
        this.setState({ dialogOpen: false })
    }

    confirm() {
        if (this.isShowBanMultiple(this.state.input.risk_label) && !this.state.ban_multiple_unset && parseFloat(this.state.input.ban_multiple) <= 0) {
            utils.addToast(this.t('invalidParams'), 'error')
            this.setState({ isLoading: false })
            return
        }

        const promiseList = []

        const updateRiskInfoPromise = new Promise((resolve, reject) => {
            utils.apiRequest(
                'patch',
                API.RISKMGT_GAME_RISK_INFO,
                {
                    id: this.state.input.id,
                    rtp_level: this.state.input.rtp_level,
                    ban_multiple: this.isShowBanMultiple(this.state.input.risk_label)
                        ? this.state.ban_multiple_unset
                            ? -1
                            : parseFloat(this.state.input.ban_multiple)
                        : undefined,
                },
                (_data) => {
                    resolve()
                },
                () => {
                    reject()
                },
                true
            )
        })
        promiseList.push(updateRiskInfoPromise)

        if (this.isShowAnotherGameRiskInfoRtp(this.state.input.risk_label)) {
            let anotherRiskLabel
            switch (this.state.input.risk_label) {
                case RISKMGT.RISK_LABEL_HONEYMOON_1:
                    anotherRiskLabel = RISKMGT.RISK_LABEL_HONEYMOON_2
                    break
                default:
                    break
            }
            const anotherRiskInfo =
                this.state.gameRiskInfo[utils.ComposeGameRiskInfoKey(this.state.input.oid, anotherRiskLabel, this.state.input.pf_sub_pf_id)]

            promiseList.push(
                new Promise((resolve, reject) => {
                    utils.apiRequest(
                        'patch',
                        API.RISKMGT_GAME_RISK_INFO,
                        {
                            id: anotherRiskInfo.id,
                            rtp_level: this.state.input.another_rtp_level,
                        },
                        (_data) => {
                            resolve()
                        },
                        () => {
                            reject()
                        },
                        true
                    )
                })
            )
        }

        Promise.all(promiseList)
            .then(() => {
                utils.addToast(this.t('success'), 'success')
                this.props.confirmCallback()
                this.closeDialog()
            })
            .catch(() => {
                // this.setState({ confirmDisabled: false });
            })
    }

    queryData = (queryParams) => {
        utils.apiRequest(
            'get',
            API.RISKMGT_RTP_LEVEL_LIST,
            queryParams,
            (data) => {
                let rtpLevelList = []
                switch (this.state.input.risk_label) {
                    case RISKMGT.RISK_LABEL_BIG_RICH_COMPENSATION:
                        rtpLevelList = [
                            ...data[this.state.input.oid][RISKMGT.RISK_LEVEL_BIGRICH],
                            ...data[this.state.input.oid][RISKMGT.RISK_LEVEL_STANDARD],
                        ]
                        break
                    case RISKMGT.RISK_LABEL_BLACKLIST:
                        rtpLevelList = data[this.state.input.oid][RISKMGT.RISK_LEVEL_BLACKLIST]
                        break
                    case RISKMGT.RISK_LABEL_HONEYMOON_1:
                        rtpLevelList = data[this.state.input.oid][RISKMGT.RISK_LEVEL_HONEYMOON]
                        break
                    default:
                        break
                }

                this.setState({ rtp_level_list: rtpLevelList })
            },
            (_err) => {},
            true
        )
    }

    isShowBanScore(riskLabel) {
        return riskLabel === RISKMGT.RISK_LABEL_BLACKLIST
    }

    isShowBanMultiple(riskLabel) {
        return riskLabel === RISKMGT.RISK_LABEL_BLACKLIST
    }

    isShowAnotherGameRiskInfoRtp(riskLabel) {
        return riskLabel === RISKMGT.RISK_LABEL_HONEYMOON_1
    }

    render() {
        return (
            <Dialog open={this.state.dialogOpen} onClose={() => this.setState({ dialogOpen: false })} fullWidth maxWidth="sm">
                <DialogTitle>
                    {this.t('Title', {
                        game_name: this.t('GameName.' + this.state.input.game_code),
                        risk_label: this.state.input.risk_label,
                    })}
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <FormControl>
                                <InputLabel>
                                    {this.isShowAnotherGameRiskInfoRtp(this.state.input.risk_label) && this.t('honeymoon1')}
                                    {this.t('rtpLabel')}
                                </InputLabel>
                                <Select
                                    value={this.state.input.rtp_level}
                                    onChange={(event) =>
                                        this.setState({
                                            input: {
                                                ...this.state.input,
                                                rtp_level: event.target.value,
                                            },
                                        })
                                    }>
                                    {this.state.rtp_level_list.map((rtp_level) => (
                                        <MenuItem value={rtp_level} key={'rtp_level__' + rtp_level}>
                                            {rtp_level}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        {this.isShowAnotherGameRiskInfoRtp(this.state.input.risk_label) ? (
                            <Grid item xs={12}>
                                <FormControl>
                                    <InputLabel>
                                        {this.t('honeymoon2')}
                                        {this.t('rtpLabel')}
                                    </InputLabel>
                                    <Select
                                        value={this.state.input.another_rtp_level}
                                        onChange={(event) =>
                                            this.setState({
                                                input: {
                                                    ...this.state.input,
                                                    another_rtp_level: event.target.value,
                                                },
                                            })
                                        }>
                                        {this.state.rtp_level_list.map((rtp_level) => (
                                            <MenuItem value={rtp_level} key={'rtp_level__' + rtp_level}>
                                                {rtp_level}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                        ) : (
                            ''
                        )}
                        {this.isShowBanScore(this.state.input.risk_label) ? (
                            <Grid item>
                                <TextField
                                    label={this.t('banMultiple')}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    value={this.state.input.ban_multiple}
                                    onChange={(event) =>
                                        this.setState({
                                            input: {
                                                ...this.state.input,
                                                ban_multiple: event.target.value,
                                            },
                                        })
                                    }
                                    margin="dense"
                                    disabled={this.state.ban_multiple_unset}
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={this.state.ban_multiple_unset}
                                            onChange={(event) => {
                                                this.setState({
                                                    ban_multiple_unset: event.target.checked,
                                                })
                                            }}
                                            name="checkedB"
                                            color="primary"
                                        />
                                    }
                                    label={this.t('unset')}
                                />
                            </Grid>
                        ) : (
                            ''
                        )}
                    </Grid>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button
                        variant="contained"
                        onClick={() => {
                            this.setState({ isLoading: true })
                            this.confirm()
                        }}
                        color="primary"
                        disabled={this.state.isLoading}>
                        {this.t('confirm')}
                    </Button>
                    <Button variant="contained" onClick={() => this.closeDialog()} color="secondary">
                        {this.t('cancel')}
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

const styles = (_theme) => {
    return {}
}

EditRiskInfoDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    onRef: PropTypes.func,
    confirmCallback: PropTypes.func,
}

export default hoc(styles)(EditRiskInfoDialog)
